import React, { useEffect, useRef, useState } from 'react'
import { CircularProgress, ListItemButton, ListItemText, Typography } from '@mui/material'
import TinyMCEEditor from '../../tinymce';
import { getContentByNoteId, updateContentByNoteId } from '../../../services/notes.service';
import { toast } from 'react-toastify';

const NotesEditor = ({ userId, selectedNoteId, selectedNoteContent, setSelectedNoteContent, isContentLoading, setIsContentLoading, setUpdatedNoteData, fromNewNote, setFromNewNote }: any) => {
  const editorRef = useRef<any>(null);
  const enableUpdateRef = useRef<any>(null);

  const fetchContentByNoteId = async () => {
    setIsContentLoading(true);
    try {
      const payload = {
        userId,
        noteId: selectedNoteId,
      }
      const contentData = await getContentByNoteId(payload);
      if (contentData?.statusCode === 200) {
        if (!enableUpdateRef.current) {
          setSelectedNoteContent(contentData?.data?.content)
        }
      } else {
        toast.error(contentData?.message);
      }
    } catch (e) {
      console.log(e);
    }
    setIsContentLoading(false);
  }

  const handleEditorChange = (note: any) => {
    setSelectedNoteContent(note);
  }

  const handleUpdateContent = async () => {

    if (!selectedNoteId) return;
    try {
      const payload = {
        userId,
        noteId: selectedNoteId,
        content: editorRef.current.getContent()
      }
      const updateContent = await updateContentByNoteId(payload);
      if (updateContent?.statusCode === 200) {
        setUpdatedNoteData(updateContent?.data)
      }
    } catch (e) {
      console.log(e, "error in update content")
    }
  }

  useEffect(() => {
    if (selectedNoteId) {
      if (!fromNewNote) {
        fetchContentByNoteId();
      } else {
        setFromNewNote(false)
      }
      enableUpdateRef.current = false;
    }
  }, [selectedNoteId])

  return (
    <>
      <div className='editor-header' >
        <Typography variant="h6" className='title'>Editor</Typography>
      </div>
      <TinyMCEEditor
        handleOnChange={handleEditorChange}
        editorValue={selectedNoteContent}
        editorRef={editorRef}
        onFocus={() => (enableUpdateRef.current = true)}
        onBlur={handleUpdateContent}
        folderName="notes"
      />
      {(isContentLoading) && (
        <ListItemButton className='position-center' sx={{ display: "flex", flexDirection: "column", gap: 1 }} >
          <CircularProgress size={20} />
          <ListItemText className="fade-text" primary="Loading..." />
        </ListItemButton>)
      }
    </>
  )
}

export default NotesEditor